import React from 'react';
import { Container } from '@mui/material';
import ShockDashboard from '../components/shock/ShockDashboard';

/**
 * Shock Analysis Page
 * Full-page view of AI News Shock system
 */
const Shock = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <ShockDashboard />
    </Container>
  );
};

export default Shock;

